// TODO проблемы:
//
// 1. проверять наличие символа
// возможно понадобится вкючить svg-sprite-loader в dependencies проекта
// beforeMount() {
//     if (
//         globalSprite.symbols.findIndex(
//             (symbol) => symbol.id == this.$props.glyph
//         ) < 0
//     ) {
//         console.warn(
//             `[${this.$options.name}]: symbol "${
//                 this.$props.glyph
//             }" not found`
//         );
//     }
// },
//
// 2. нужно обеспечить вариативность иконок (ипортировать только то что нужно для конкретного проекта)
// сейчас если экспортировать в index.js иконки они все будут включены в спрайт
import Vue from 'vue';
import './MtIcon.css';
export default Vue.extend({
    name: 'MtIcon',
    props: {
        glyph: {
            type: String,
        },
        width: {
            type: [String, Number],
        },
        height: {
            type: [String, Number],
        },
    },
    beforeMount: function () {
        var sprite = document.getElementById('__SVG_SPRITE_NODE__');
        if (!sprite) {
            console.log(process.env.NODE_ENV);
            return console.warn("[" + this.$options.name + "]: cannot find icons sprite" + (process.env.NODE_ENV === 'development'
                ? '. See docs' // TODO ссылка на доку
                : ''));
        }
        var symbol = sprite.ownerDocument.getElementById(this.$props.glyph);
        if (!symbol) {
            console.warn("[" + this.$options.name + "]: symbol \"" + this.$props.glyph + "\" not found");
        }
    },
    render: function (h) {
        var use = h('use', {
            attrs: {
                'xlink:href': "#" + this.glyph,
            },
        });
        var svg = h('svg', {
            staticClass: 'mt-icon',
            attrs: {
                width: this.width,
                height: this.height,
            },
        }, [use]);
        return svg;
    },
});
//# sourceMappingURL=MtIcon.js.map